<div class="wl-left-nav-container">
  <wl-events-left-nav></wl-events-left-nav>
</div>
